import { Component, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { HeaderOneComponent } from '../shared/header/header-one/header-one.component';
@Component({
  standalone: true,
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss'],
  imports: [RouterModule, CommonModule, HeaderOneComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ShopComponent {
  [key: string]: any;
  constructor() {
  }



  ngOnInit(): void {
  }


}